const englishWords = {
  //general
  back: "Back",
  delete: "Delete",
  new_data: "Add",
  upload: "Upload",
  reset_data: "Reset",
  update_data: "Update",
  save_data: "Save",
  filter_show: "Show Filter",
  filter_hide: "Hide Filter",
  filter_clear: "Clear Filter",
  load_more: "Load More",
  please_complete_data: "Please complete the data!",
  data_not_complete: "Data not complete",
  minimum_3_characters: "Minimum 3 character",
  minimum_character_length: "Minimum character length is",
  maximum_character_length: "Maximum character length is",
  reset_form: "Reset",
  search_data: "Search",
  data_status_all: "All Status",
  data_status_active: "Active",
  data_status_inactive: "Inactive",
  delete_alert: "Your delete request will be processed. Are you sure?",
  activate_alert: "This data will be activated. Are you sure?",
  deactivate_alert: "This data will be deactivated. Are you sure?",
  confirmation: "Confirmation",
  yes: "Yes",
  no: "No",
  cancel: "Cancel",
  no_data_found: "Data not found",
  new_password: "New password",
  current_password: "Current password",
  confirm_password: "Password confirmation",
  old_password: "Old password",
  printButtonLabel: "Print",
  floating_chat_title: "Hi, what's on your thought?",
  back_to_tms_warning: "You will be redirected back to TMS. Are you sure?",
  show_detail: "Show Detail",
  floating_chat_tooltip: "Hi, i'm Esti, your AI assistant",
  floating_chat_tooltip_sub: "Anything I can help with?",
  session_expired: "Your session has expired, please sign in to continue",

  //general word (becareful when you want to change the value)
  word_created_date: "Created Date",
  word_transport_type: "Transport Type",
  word_load_type: "Load Type",
  word_vehicle_type: "Vehicle Type",
  word_name: "Name",
  word_action: "Action",
  word_choose: "Choose",
  from_date: "From date",
  to_date: "To date",
  has_been_added: "has been added",
  has_been_updated: "has been updated",
  has_been_deleted: "has been deleted",
  has_been_activated: "has been activated",
  has_been_deactivated: "has been deactivated",
  delete_success: "Data has been inactivate",
  delete_failed: "Fail to inactivate data",
  activate_success: "Successfully activating data",
  activate_failed: "Failed to activate data",
  fetch_success: "Successfully fetching data",
  notification: "Notification",
  notification_setting: "Notification Setting",
  table_no_data_found: "No data available",
  invalid: "Invalid",

  no_data: "No Data",
  no_notification: "No notification found",

  //user
  user_setting_title: "User Settings",
  user_data_title: "Personal Information",
  company_data_title: "Company Information",
  user_changepassword_title: "Change Password",
  user_form_firstname: "First Name",
  user_form_lastname: "Last Name",
  user_form_company: "Company",
  user_form_country: "City",
  user_form_postal_code: "Postal Code",
  user_form_province: "Province",
  user_form_email: "Email",
  user_form_phone: "Phone",
  user_form_mobile_phone: "Mobile Phone",
  user_form_address: "Address",
  user_form_oldpassword: "Old Password",
  user_form_newpassword: "New Password",
  user_form_confirmpassword: "Confirm Password",
  user_form_confirmpasswordwarning: "Password is not match!",

  user_placeholder_firstname: "First name",
  user_placeholder_lastname: "Last name",
  user_placeholder_company: "Company name",
  user_placeholder_email: "EMAIL",
  user_placeholder_phone: "Phone number",
  user_placeholder_address: "ADDRESS",
  user_placeholder_city: "CITY",
  user_placeholder_postalcode: "POSTAL CODE",
  user_placeholder_province: "PROVINCE",
  user_placeholder_oldpassword: "Old password",
  user_placeholder_newpassword: "New password",
  user_placeholder_confirmpassword: "Confirm new password",

  user_update_success: "Update User Success",
  user_update_failed: "Update User Failed",
  user_changepassword_success: "Change Password Success",
  user_changepassword_failed: "Change Password Failed",
  user_changepassword_notmatch:
    "New password confirmation failed, password is not match.",

  //partner
  partner_search_name: "Search by Name",
  partner_search_email: "Search by Email",
  partner_search_phone: "Search by Phone",
  partner_search_address: "Search by Address",
  partner_table_title: "List Partner",
  partner_add_title: "Add New Partner",
  partner_edit_title: "Edit Partner Data",
  partner_label_name: "Name",
  partner_label_email: "Email",
  partner_label_phone: "Phone Number",
  partner_label_transport_type: "Transport Type",
  partner_label_address: "Address",
  partner_placeholder_name: "Name",
  partner_placeholder_email: "EMAIL",
  partner_placeholder_phone: "Phone number",
  partner_placeholder_transport_type: "PICK THE TRANSPORT TYPE",
  partner_placeholder_address: "Address",
  partner_placeholder_filterbyname: "Filter by name",
  partner_tableheader_id: "Partner ID",
  partner_tableheader_name: "Name",
  partner_tableheader_email: "Email",
  partner_tableheader_transport_type: "Transport Type",
  partner_tableheader_phone: "Phone Number",
  partner_tableheader_address: "Address",
  partner_tableheader_createddate: "Created Date",
  partner_tableheader_updateddate: "Last Updated",
  partner_tableheader_action: "Action",
  partner_notif_add_title: "Add Partner Success",
  partner_notif_add_subtitle: "A partner as been added",
  partner_notif_edit_title: "Update Partner Success",
  partner_notif_edit_subtitle: "A partner has been updated",
  partner_fetch_failed: "Failed to fetch partner data",
  partner_add_success: "Add Partner Success",
  partner_add_failed: "Add Partner Failed",
  partner_edit_success: "Update Partner Success",
  partner_edit_failed: "Update Partner Failed",
  partner_delete_success: "Disable Partner Success",
  partner_delete_failed: "Disable Partner Failed",
  partner_activate_success: "Activate Partner Success",
  partner_activate_failed: "Activate Partner Failed",
  //customer
  customer: "Customer",
  customer_search_name: "Search by Name",
  customer_search_email: "Search by Email",
  customer_search_phone: "Search by Phone",
  customer_search_address: "Search by Address",
  customer_search_created_date: "Search by Created Date",
  customer_search_updated_date: "Search by Updated Date",
  customer_table_title: "List Customer",
  customer_add_title: "Add New Customer",
  customer_edit_title: "Edit Customer Data",
  customer_add_pic: "PIC",
  customer_add_fax: "Fax",
  customer_add_country: "Country",
  customer_add_province: "Province",
  customer_add_city: "City",
  customer_add_postalcode: "Postal Code",
  customer_add_taxno: "Tax Number",
  customer_add_taxname: "Tax Name",
  customer_add_taxaddress: "Tax Address",
  customer_add_name: "Name",
  customer_add_email: "Email",
  customer_add_phone: "Phone Number",
  customer_add_prefix: "Prefix",
  customer_add_address: "Address",
  customer_add_success_title: "Confirmation",
  customer_add_success_text:
    "Customer data successfully added! Do you want to add the location too?",
  customer_placeholder_name: "Name",
  customer_placeholder_email: "Email",
  customer_placeholder_phone: "Phone number",
  customer_placeholder_prefix: "Pick the prefix",
  customer_placeholder_fax: "Fax",
  customer_placeholder_address: "Address",
  customer_placeholder_country: "Country",
  customer_placeholder_province: "Province",
  customer_placeholder_city: "City",
  customer_placeholder_pic: "PIC",
  customer_placeholder_postalcode: "Postal Code",
  customer_placeholder_taxno: "Tax Number",
  customer_placeholder_taxname: "Tax Name",
  customer_placeholder_taxaddress: "Tax Address",
  customer_tableheader_id: "Customer ID",
  customer_tableheader_name: "Name",
  customer_tableheader_email: "Email",
  customer_tableheader_vendor: "Transport Type",
  customer_tableheader_phone: "Phone Number",
  customer_tableheader_pic: "PIC",
  customer_tableheader_address: "Address",
  customer_tableheader_companyname: "Company Name",
  customer_tableheader_createddate: "Created Date",
  customer_tableheader_updateddate: "Updated Date",
  customer_tableheader_action: "Action",
  customer_tableheader_picklocation: "Choose Location",
  customer_warning_nolocation:
    "This customer has no location assigned. You can add the location in customer detail page.",
  customer_filter_name: "Filter by name",
  customer_filter_from_date: "From date",
  customer_filter_to_date: "To date",
  customer_filter_address: "Filter by address",
  customer_filter_pic: "Filter by PIC name",
  customer_filter_phone: "Filter by phone",
  customer_add_success: "Add Customer Success",
  customer_add_failed: "Add Customer Failed",
  customer_update_success: "Update Customer Success",
  customer_update_failed: "Update Customer Failed",
  customer_activate_success: "Activate Customer Success",
  customer_activate_failed: "Activate Customer Failed",

  test: "Ini adalah test english",
  navbar_title: "NAVBAR TITLE",
  home_banner_title: `HELLO, THANKS FOR COMING!`,
  home_banner_desc: `This Vue 3 application is using libraries such as Bootstrap 5 and Vuetify. Most of the components used in this App are from Vuetify version 3.xx that supported Vue 3.`,
  home_banner_vue3: `View Vue 3`,
  home_banner_vuetify: `View Vuetify`,
  home_banner_bootstrap5: `View Bootstrap 5`,
  home_banner_explore: `Start to Explore`,

  // location
  location: "Location",
  location_form_add_title: "Add Location Data",
  location_form_edit_title: "Edit Location Data",
  location_data_title: "Location Data",
  location_form_name: "Name",
  location_form_pic: "PIC",
  location_form_phone: "Phone",
  location_form_address: "Address",
  location_form_country: "Country",
  location_form_province: "Province",
  location_form_city: "City",
  location_form_district: "District",
  location_form_postal_code: "Postal Code",
  location_form_notes: "Note: Currently editing location detail of",
  location_form_cancel: "Cancel",
  location_form_reset: "Reset Data",
  location_form_submit: "Submit Location",
  location_placeholder_address: "Enter a location",
  location_placeholder_country: "Enter a country",
  location_placeholder_province: "Enter a province",
  location_placeholder_city: "Enter a city",
  location_placeholder_district: "Enter a district",
  location_placeholder_postal_code: "Enter a postal code",
  location_search_name: "Search by Name",
  location_search_pic: "Search by PIC",
  location_search_phone: "Search by Phone",
  location_search_address: "Search by Address",
  location_search_created_date: "Search by Created Date",
  location_search_updated_date: "Search by Updated Date",
  location_table_header: "Location List",
  location_table_header_name: "Name",
  location_table_header_pic: "PIC",
  location_table_header_phone: "Phone Number",
  location_table_header_address: "Address",
  location_table_header_created: "Created Date",
  location_table_header_updated: "Last Updated",
  location_table_header_action: "Action",
  location_add_success: "Add Location Success",
  location_add_failed: "Add Location Failed",
  location_update_success: "Update Location Success",
  location_update_failed: "Update Location Failed",

  fetching_countries_error: "Fetching Countries Data Failed",
  fetching_provinces_error: "Fetching Provinces Data Failed",
  fetching_cities_error: "Fetching Cities Data Failed",
  fetching_districts_error: "Fetching Districts Data Failed",

  // Error
  must_number_error: "must be number!",
  is_required: "is required!",
  not_valid: "is not valid!",
  err_msg_500: "Something went wrong, please try again later",
  invalid_location: "Please select an available location!",

  // order
  order_table_title: "List Order",
  order_tableheader_orderid: "Order ID",
  order_tableheader_ordernumber: "Order Number",
  order_label_orderstatus: "Order Status",
  order_tableheader_city: "City",
  order_tableheader_createddate: "Created Date",
  order_tableheader_updatedat: "Last Updated",
  order_tableheader_customername: "Customer Name",
  order_tableheader_customerid: "Customer ID",
  order_tableheader_origincity: "Origin City",
  order_tableheader_destinationcity: "Destination City",
  order_tableheader_originaddress: "Origin Address",
  order_tableheader_destinationaddress: "Destination Address",
  order_tableheader_orderstatus: "Order Status",
  order_tableheader_status: "Status",
  invoice_tableheader_status: "Invoice Status",
  order_label_customer: "Customer",
  order_label_customerpic: "PIC",
  order_label_customeremail: "Email",
  order_label_customerphone: "Phone",
  order_label_origin: "Origin Location",
  order_label_origincity: "Origin City",
  order_label_originaddress: "Origin Address",
  order_label_destination: "Destination Location",
  order_label_destinationcity: "Destination City",
  order_label_destinationaddress: "Destination Address",
  order_label_ordernumber: "Order Number",
  order_label_remark: "Remarks",
  order_add_title: "Add New Order",
  order_edit_title: "Edit Order Data",
  order_placeholder_customer: "Search customer",
  order_placeholder_customerpic: "Customer PIC",
  order_placeholder_customeremail: "CUSTOMER EMAIL",
  order_placeholder_customerphone: "Customer phone",
  order_placeholder_origin: "Origin location",
  order_placeholder_origincity: "Origin city",
  order_placeholder_originaddress: "Origin address",
  order_placeholder_destination: "Destination location",
  order_placeholder_destinationcity: "Destination city",
  order_placeholder_destinationaddress: "Destination address",
  order_placeholder_ordernumber: "Order number",
  order_placeholder_filterbyordernumber: "Filter by order number",
  order_add: "Add Order",
  order_add_redirect:
    "Add order success! Do you want to input the order detail (you will be redirected to order detail page)?",
  order_add_success: "Add Order Success",
  order_add_failed: "Add Order Failed",
  order_edit_success: "Update Order Success",
  order_edit_failed: "Update Order Failed",
  sla: "SLA",
  start_order: "Start Order",
  finish_order: "Finish Order",
  contact: "Contact",
  emergency: "Emergency",
  contact_type: "Contact Type",
  contact_name: "Contact Name",
  add_contact: "Add Contact",
  add_contact_failed: "Add driver contact failed",
  edit_contact: "Edit Contact",
  edit_contact_failed: "Edit driver Contact failed",

  purchase_order_add_success: "Add Purchase Order Success",
  purchase_order_add_failed: "Add Purchase Order Failed",

  order_location_list: "Location List",
  order_origin_location: "Pick Origin Location",
  order_destination_location: "Pick Destination Location",
  order_customer_modal: "Pick Customer",
  order_customer_list: "Customer List",
  order_sla: "Order SLA (Hours)",

  //order detail
  orderdocument_table_title: "List Order Document",
  orderdetail_table_title: "List Order Detail",
  orderdetail_tableheader_orderdetailid: "ID",
  orderdetail_tableheader_oriaddress: "Origin Address",
  orderdetail_tableheader_destaddress: "Destination Address",
  orderdetail_tableheader_transporttype: "Transport Type",
  orderdetail_tableheader_loadtype: "Load Type",
  orderdetail_tableheader_movetype: "Move Type",
  orderdetail_tableheader_containertype: "Container Type",
  orderdetail_tableheader_vehicletype: "Vehicle Type",
  orderdetail_tableheader_partner: "Partner",
  orderdetail_tableheader_startdate: "Start Date",
  orderdetail_tableheader_enddate: "Finish Date",
  orderdetail_tableheader_createddate: "Created Date",
  orderdetail_tableheader_updatedate: "Last Updated",
  loading_list_status: "Loading List Status",
  orderdetail_tableheader_orderdetailno: "Order Detail No",
  orderdetail_label_orderdetailid: "ID",
  orderdetail_label_oriaddress: "Origin Address",
  orderdetail_label_destaddress: "Destination Address",
  orderdetail_label_transporttype: "Transport Type",
  orderdetail_label_loadtype: "Load Type",
  orderdetail_label_movetype: "Move Type",
  orderdetail_label_containertype: "Container Type",
  orderdetail_label_vehicletype: "Vehicle Type",
  orderdetail_label_partner: "Partner",
  orderdetail_label_startdate: "Order Start Date",
  orderdetail_label_enddate: "Order Finish Date",
  orderdetail_label_createddate: "Created Date",
  orderdetail_label_updatedat: "Last Updated",
  orderdetail_label_qty: "Qty",
  orderdetail_add_title: "Add Order Detail",
  orderdetail_edit_title: "Edit Order Detail",
  orderdetail_label_orderdetailno: "Order Detail Number",
  orderdetail_placeholder_orderdetailno: "ORDER DETAIL NUMBER",
  orderdetail_placeholder_originaddress: "Origin address",
  orderdetail_placeholder_destinationaddress: "Destination address",
  orderdetail_placeholder_transporttype: "Transport type",
  orderdetail_placeholder_loadtype: "Load type",
  orderdetail_placeholder_movetype: "Move type",
  orderdetail_placeholder_vehicletype: "Vehicle type",
  orderdetail_placeholder_containertype: "Container type",
  orderdetail_placeholder_qty: "Qty",
  orderdetail_placeholder_partner: "PARTNER",
  orderdetail_placeholder_startjobdate: "START DATE",
  orderdetail_placeholder_endjobdate: "FINISH DATE",
  orderdetail_add_success: "Add Order Detail Success",
  orderdetail_add_failed: "Add Order Detail Failed",
  orderdetail_edit_success: "Update Order Detail Success",
  orderdetail_edit_failed: "Update Order Detail Failed",
  orderdetail_delete_success: "Delete Order Detail Success",
  orderdetail_delete_failed: "Delete Order Detail Failed",
  orderdetail_warning_jobdate: "Start date must be earlier than finish date",

  // Order container
  ordercontainer_table_title: "List Order Container",
  ordercontainer_nocontainer: "No Container",
  ordercontainer_containertype: "Container Type",
  ordercontainer_sealnumber: "Seal Number",
  ordercontainer_store_success: "Successfully added container data",
  ordercontainer_store_fail: "Failed to add container data",
  ordercontainer_update_success: "Successfully updated container data",
  ordercontainer_update_fail: "Failed to updated container data",

  // Track status
  trackstatus_table_title: "List Track Status",
  trackstatus_status_name: "Status",
  trackstatus_status_date_time: "Date & Time",
  trackstatus_remark: "Remark",
  trackstatus_created_at: "Created At",
  trackstatus_order_no: "Order No",
  trackstatus_order_detail_no: "Order Detail No",
  trackstatus_status: "Status",
  Trackstatus_store_success: "Successfully added track status",
  Trackstatus_store_fail: "Failed to add track status",
  Trackstatus_update_success: "Successfully updated track status",
  Trackstatus_update_fail: "Failed to update track status",

  orderpurchase_table_title: "List Purchase Order",
  orderpurchase_nopo: "Purchase Order Number",
  orderpurchase_partnername: "Partner Name",
  orderpurchase_totalpo: "Grand Total",
  orderpurchase_container_type: "Container Type",
  orderpurchase_qty: "Quantity",
  orderpurchase_freight_element: "Freight Element",
  orderpurchase_vehicle_type: "Vehicle Type",
  orderpurchase_amount: "Amount",
  orderpurchase_tax: "Tax",
  orderpurchase_subtotal: "Subtotal",
  orderpurchase_total: "Total",
  orderpurchase_remark: "Remark",
  orderpurchase_get_failed: "Failed to get purchase order data",
  orderpurchase_update_success: "Successfully updated purchase order data",
  orderpurchase_update_fail: "Failed to updated purchase order data",
  orderpurchase_detail_get_failed: "Failed to get purchase order detail",
  orderpurchase_orderdetail: "Order Detail Number",

  orderpurchase_detail_store_success:
    "Successfully added detail purchase order data",
  orderpurchase_detail_store_failed: "Failed added detail purchase order data",
  orderpurchase_detail_update_success:
    "Successfully updated detail purchase order data",
  orderpurchase_detail_update_failed:
    "Failed updated detail purchase order data",
  orderpurchase_detail_destroy_success:
    "Successfully deleted detail purchase order data",
  orderpurchase_detail_destroy_failed:
    "Failed deleted detail purchase order data",

  // Order - Trucking
  ordertrucking_table_title: "List Order Trucking",
  ordertrucking_truckingorderno: "Trucking Order No",
  ordertrucking_containerno: "Container No",
  ordertrucking_vehicletype: "Vehicle Type",
  ordertrucking_orderdate: "Order Date",
  ordertrucking_companyorderdetailid: "Company Order Detail",
  ordertrucking_orderdetailno: "Order Detail Number",
  ordertrucking_partnerfleetid: "Partner Fleet",
  ordertrucking_location: "Location",

  order_trucking: "Order Trucking",
  ordertrucking_add_title: "Add New Trucking",
  ordertrucking_store_success: "Successfully added order trucking data",
  ordertrucking_store_failed: "Failed added order trucking data",
  ordertrucking_add_success_text:
    "Order trucking data successfully added! Do you want to look the detail too?",

  ordertrucking_update_title: "Update Trucking Data",
  ordertrucking_update_success: "Successfully update order trucking data",
  ordertrucking_update_failed: "Failed update order trucking data",

  order_trucking_milestone: "Order Trucking Milestone",
  order_trucking_milestone_add: "Add New Trucking Milestone",
  order_trucking_milestone_edit: "Edit Trucking Milestone",
  ordertrucking_milestone_store_success:
    "Successfully added order trucking milestone data",
  ordertrucking_milestone_store_failed:
    "Failed added order trucking milestone data",
  ordertrucking_milestone_update_success:
    "Successfully updated order trucking milestone data",
  ordertrucking_milestone_update_failed:
    "Failed updated order trucking milestone data",

  // Invoice
  invoice_table_title: "List Invoice",
  invoice_invoice_type: "Invoice Type",
  invoice_grand_total: "Grand Total",
  invoice_due_date: "Due Date",
  invoice_credit_days: "Credit Days",
  invoice_customer: "Customer",
  invoice_payer_name: "Payer",
  invoice_payment_type: "Payment Type",
  invoice_remark: "Remark",
  invoice_vehicle_type: "Vehicle Type",

  invoice_get_failed: "Failed to get customer invoice data",
  invoice_detail_get_failed: "Failed to get customer invoice detail",
  invoice_add_data: "Add Customer Invoice",
  invoice_add_data_success: "Add customer invoice success",
  invoice_add_data_failed: "Add customer invoice failed",
  invoice_add_data_redirect:
    "Add customer invoice success! Do you want to input the detail (you will be redirected to invoice detail page)?",
  invoice_edit_data: "Edit Customer Invoice",
  invoice_edit_data_success: "Edit customer invoice success",
  invoice_edit_data_failed: "Edit customer invoice failed",

  invoice_detail_store_success: "Successfully added detail invoice data",
  invoice_detail_store_failed: "Failed added detail invoice data",
  invoice_detail_update_success: "Successfully updated detail invoice data",
  invoice_detail_update_failed: "Failed updated detail invoice data",
  invoice_detail_destroy_success: "Successfully deleted detail invoice data",
  invoice_detail_destroy_failed: "Failed deleted detail invoice data",

  invoice_type_fetch_failed: "Failed to fetch invoice type",
  payment_type_fetch_failed: "Failed to fetch payment type",
  customer_fetch_failed: "Failed to fetch customer",

  invoicevendor_invoice_no: "Invoice No",
  invoicevendor_order_no: "Order No",
  invoicevendor_invoice_date: "Invoice Date",
  invoicevendor_orderno: "Order No",
  invoicevendor_partner: "Partner",
  invoicevendor_tax: "Tax %",
  invoicevendor_status: "Status",
  invoicevendor_total_amount: "Total Amount",
  invoicevendor_placeholder_filterbyinvoiceno: "Filter by invoice number",
  invoicevendor_placeholder_filterbyorderno: "Filter by order number",
  invoicevendor_placeholder_partner: "Search Partner",
  invoicevendor_add_data: "Add New Vendor Invoice",
  invoicevendor_add_data_success: "Add vendor invoice success",
  invoicevendor_add_data_failed: "Add vendor invoice failed",
  invoicevendor_add_data_redirect:
    "Add vendor invoice success! Do you want to input the detail (you will be redirected to vendor invoice detail page)?",
  invoicevendor_edit_data: "Edit Vendor Invoice",
  invoicevendor_edit_data_success: "Edit vendor invoice success",
  invoicevendor_edit_data_failed: "Edit vendor invoice failed",
  invoicevendor_table_title: "List Vendor Invoice",
  invoicevendor_get_failed: "Failed to get vendor invoice data",

  invoicevendor_detail_get_failed: "Failed to get vendor invoice detail",
  invoicevendor_detail_freight_element: "Freight Element",
  invoicevendor_detail_amount: "Amount",
  invoicevendor_detail_qty: "Quantity",
  invoicevendor_detail_tax: "Tax %",
  invoicevendor_detail_subtotal: "Subtotal",
  invoicevendor_detail_total: "Total",
  invoicevendor_detail_remark: "Remark",

  invoicevendor_detail_store_success:
    "Successfully added detail vendor invoice data",
  invoicevendor_detail_store_failed: "Failed added detail vendor invoice data",
  invoicevendor_detail_update_success:
    "Successfully updated detail vendor invoice data",
  invoicevendor_detail_update_failed:
    "Failed updated detail vendor invoice data",
  invoicevendor_detail_destroy_success:
    "Successfully deleted detail vendor invoice data",
  invoicevendor_detail_destroy_failed:
    "Failed deleted detail vendor invoice data",

  // report/truckposition
  fleet_placeholder: "FLEET",
  partner_name: "Partner Name",
  map_view: "Map View",
  view_data: "Data View",
  partnerfleet: "Fleet",
  refresh: "Refresh Data",
  close: "Close",
  open: "Open",
  device_id: "Device ID",
  device_code: "Device Code",
  door_number: "Door Number",
  door_left: "Door Left",
  door_rear: "Door Rear",
  door_right: "Door Right",
  fuel_level: "Fuel Level",
  last_update: "Last Update",
  latitude: "Latitude",
  longitude: "Longitude",
  latlong: "Lat / Long",
  odometer: "Odometer",
  reg_number: "Registration Number",
  reg_number_with_door: "Registration Number With Door",
  speed: "Speed (km/h)",
  temp_c: "Temperature (Celcius)",
  trucking_position_id: "Trucking Position ID",
  vsys: "VSYS",
  machine: "Machine",
  update_date: "Updated Date",
  search: "Search by ",
  fetch_failed: "Failed to retrieve data",
  address: "Address",

  //Sample Page
  sample_page_title: "Sample Page",
  sample_page_subtitle:
    "This page is containing samples (GET, POST, etc.) for study purpose.",
  get_sample_data: "GET Sample Data",
  get_sample_data_desc:
    "In this section, we will try to use the Vuex Action combined with native js API call for GET request to get some datas.",

  post_sample_data: "POST Sample Data",
  post_sample_data_desc:
    "In this section, we will try to use the Vuex Action combined with native js API call for POST request to save the data.",

  put_sample_data: "PUT Sample Data",
  put_sample_data_desc:
    "In this section, we will try to use the Vuex Action combined with native js API call for PUT request to update the data.",

  delete_sample_data: "DELETE Sample Data",
  delete_sample_data_desc:
    "In this section, we will try to use the Vuex Action combined with native js API call for DELETE request to delete a data.",

  //Home Page
  get_sample_port: "GET Port Data",

  // Button
  btn_print: "Print",
  btn_download: "Download",

  // Button Tooltip
  btn_tooltip_back: "Return to previous page",
  btn_tooltip_update: "Update",
  btn_tooltip_search: "Search",
  btn_tooltip_add: "Add",
  btn_tooltip_upload: "Upload",
  btn_tooltip_delete: "Delete",
  btn_tooltip_inactive: "Inactivate",
  btn_tooltip_edit: "Edit",
  btn_tooltip_view: "View",
  btn_tooltip_reset: "Reset",
  btn_tooltip_active: "Activate",
  btn_tooltip_location: "Pick location",
  btn_tooltip_submit: "Submit",
  btn_tooltip_cancel: "Cancel",
  btn_tooltip_truck: "truck position",
  btn_tooltip_refresh_truck: "Get the latest truck position data",

  btn_tooltip_print_order: "Print Order Summary",
  btn_tooltip_print_po: "Print PO",
  btn_tooltip_add_po: "Add PO",
  btn_tooltip_edit_po: "Edit PO",
  btn_tooltip_download_document: "Download Document",
  btn_tooltip_delete_document: "Delete Document",
  btn_tooltip_save: "Save",

  btn_customer_invoice: "Customer Invoice",

  // Back confirmation
  confirm_back: "All your unsaved data will be erased. Are you sure?",

  //general_use
  add_order_detail: "Add Order Detail",
  add_container: "Add Container",
  add_track_status: "Add Track Status",
  edit_order_detail: "Edit Order Detail",
  edit_container: "Edit Container",
  add_document: "Add Document",
  document_name: "Document Name",
  document_type: "Document Type",
  container_type: "Container Type",
  remark: "Remark",
  status: "Status",
  document: "Document",
  partner: "Partner",
  uploaded_by: "Uploaded By",
  uploaded_on: "Uploaded On",

  // Fleet
  fleet_table_title: "List Fleet Partner",
  fleet_activate_success: "Activate Fleet Partner Success",
  fleet_activate_failed: "Activate Fleet Partner Failed",
  fleet_inactivate_success: "Inactivate Fleet Partner Success",
  fleet_inactivate_failed: "Inactivate Fleet Partner Failed",
  fleet_fetch_failed: "Failed to fetch fleet partner data",

  fleet_tableheader_name: "Name",
  fleet_tableheader_partner: "Partner",
  fleet_tableheader_vehicle_type: "Vehicle Type",
  fleet_tableheader_transport_type: "Transport Type",
  fleet_tableheader_plate_number: "Number Plate",
  fleet_tableheader_hull_number: "Hull Number",
  fleet_tableheader_created_date: "Created Date",
  fleet_tableheader_updated_date: "Last Updated",
  fleet_tableheader_action: "Action",

  fleet_search_name: "Search by name",
  fleet_search_partner: "Search by partner",
  fleet_search_vehicle_type: "Search by vehicle type",
  fleet_search_transport_type: "Search by transport type",
  fleet_search_updated_date: "Search by updated date",
  fleet_search_created_date: "Search by created date",
  fleet_search_hull_number: "Search by hull number",
  fleet_search_plate_number: "Search by number plate",

  fleet_add_name: "Name",
  fleet_add_plate_number: "Number Plate",
  fleet_add_hull_number: "Hull Number",
  fleet_add_partner: "Partner",
  fleet_add_vehicle_type: "Vehicle Type",
  fleet_add_transport_type: "Transport Type",
  fleet_add_primary_driver: "Primary Driver",
  fleet_add_secondary_driver: "Secondary Driver",
  fleet_add_brand: "Brand",

  fleet: "Fleet Partner",
  fleet_add_success: "Add Fleet Partner Success",
  fleet_add_failed: "Add Fleet Partner Failed",

  fleet_add_title: "Add Fleet Partner",
  fleet_edit_title: "Edit Fleet Partner",
  fleet_view_title: "View Fleet Partner",

  fleet_placeholder_name: "NAME",
  fleet_placeholder_plate_number: "NUMBER PLATE",
  fleet_placeholder_hull_number: "HULL NUMBER",
  fleet_placeholder_partner: "CHOOSE PARTNER",
  fleet_placeholder_vehicle_type: "PICK VEHICLE TYPE",
  fleet_placeholder_transport_type: "PICK TRANSPORT TYPE",

  fleet_edit_success: "Update Fleet Partner Success",
  fleet_edit_failed: "Update Fleet Partner Failed",

  // Freight
  freight_table_title: "List Freight Element",
  freight_activate_success: "Activate Freight Element Success",
  freight_activate_failed: "Activate Freight Element Failed",
  freight_inactivate_success: "Inactivate Freight Element Success",
  freight_inactivate_failed: "Inactivate Freight Element Failed",
  freight_fetch_failed: "Failed to fetch freight element data",

  freight_tableheader_code: "Freight Element Code",
  account_tableheader_code: "Account Code",
  freight_tableheader_description: "Name",
  freight_tableheader_created_at: "Created Date",
  freight_tableheader_updated_at: "Last Updated",
  freight_tableheader_action: "Action",

  freight_search_code: "Search by code",
  account_search_code: "Search by account",
  freight_search_description: "Search by name",
  freight_search_updated_at: "Search by updated date",
  freight_search_created_at: "Search by created date",

  freight_add_code: "Freight Element Code",
  account_add_code: "Account Code",
  freight_add_description: "Name",

  freight: "Freight Element",
  code: "Code",
  freight_add_success: "Add Freight Element Success",
  freight_add_failed: "Add Freight Element Failed",

  freight_add_title: "Add Freight Element",
  freight_edit_title: "Edit Freight Element",
  freight_view_title: "View Freight Element",

  freight_placeholder_code: "FREIGHT ELEMENT CODE",
  account_placeholder_code: "ACCOUNT CODE",
  freight_placeholder_desc: "NAME",

  freight_edit_success: "Update Freight Element Success",
  freight_edit_failed: "Update Freight Element Failed",

  freight_placeholder_filterbycode: "Filter by code",
  freight_placeholder_filterbyname: "Filter by name",
  word_code: "Code",
  freight_code_not_unique_error: "Freight element code already used!",

  // Command Center
  tableheader_job_order_number: "Job Order Number",
  tableheader_plat_number: "Number Plate",
  tableheader_speed: "Speed (km/h)",
  tableheader_status: "Status",
  tableheader_latlong: "Latitude, Longitude",
  tableheader_last_update: "Last Update",
  status_fetch_job_position_failed: "Failed to retrieve command center data",
  status_fetch_latest_job_position_failed:
    "Failed to retrieve latest command center data",
  status_fetch_job_position_total_status_failed:
    "Failed to retrieve dashboard total status data",
  inland_departure_trucking_assigned:
    "This data shows the number of confirmed bookings",
  inland_departure_depart_from_depo:
    "This data shows the number of trucks that have departed from the depot",
  inland_departure_arrived_at_warehouse:
    "This data shows the number of trucks that have arrived at the warehouse",
  inland_arrival_trucking_assigned:
    "This data shows the number of confirmed bookings",
  inland_arrival_depart_from_depo:
    "This data shows the number of trucks that have departed from the depot",
  inland_arrival_arrived_at_warehouse:
    "This data shows the number of trucks that have arrived at the warehouse",

  //po
  purchase_order_number: "Purchase Order Number",
  purchase_order_add: "Add Purchase Order",
  po_date: "Purchase Order Date",
  purchase_order_add_redirect:
    "Add purchase order success! Do you want to input the detail (you will be redirected to purchase order detail page)?",
  purchase_order_add_title: "Add New Purchase Order",
  purchase_order_edit_title: "Edit Purchase Order",
  status_fetch_failed: "Failed to fetch status",
  select_fill_status: "STATUS",
  edit_data: "Edit",

  no_header: "No",
  no_label: "No",

  // General Setting User
  general_setting_filter_name_label: "Name",
  general_setting_filter_name_placeholder: "Filter by name",
  general_setting_header_user_id: "User ID",
  general_setting_header_role: "Role",
  general_setting_header_fullname: "Fullname",
  general_setting_header_email: "Email",
  general_setting_header_phone: "Phone Number",
  general_setting_header_created_at: "Created Date",
  general_setting_header_transaction_type: "Transaction Type",
  general_setting_header_pattern: "Pattern",
  general_setting_header_preview: "Preview",
  general_setting_add_user: "Add New User",
  general_setting_edit_user: "Edit User",
  general_setting_form_firstname: "First Name",
  general_setting_form_lastname: "Last Name",
  general_setting_form_email: "Email",
  general_setting_form_phone: "Phone Number",
  general_setting_add_numbering: "Add New Number",
  general_setting_edit_numbering: "Edit Number",

  general_setting_add_success: "Add user success",
  general_setting_add_failed: "Add user failed",
  general_setting_edit_success: "Edit user success",
  general_setting_edit_failed: "Edit user failed",
  general_setting_activate_success: "Activate user success",
  general_setting_activate_failed: "Activate user failed",
  general_setting_inactivate_success: "Inactivate user success",
  general_setting_inactivate_failed: "Inactivate user failed",
  general_setting_add_numbering_success: "Add number success",
  general_setting_add_numbering_failed: "Add number failed",
  general_setting_edit_numbering_success: "Edit number success",
  general_setting_edit_numbering_failed: "Edit number failed",
  general_setting_inactivate_numbering_success: "Inactivate number success",
  general_setting_inactivate_numbering_failed: "Inactivate number failed",
  general_setting_user_notif_fetch_failed:
    "Failed to fetch notification recepient data",
  general_setting_user_notif_update_success:
    "Update Notification Recepient Success",
  general_setting_user_notif_update_failed:
    "Update Notification Recepient Failed",

  // General Setting Role
  role_tableheader_name: "Name",
  role_tableheader_created_at: "Created date",
  role_tableheader_updated_at: "Last updated",
  role_tableheader_status: "Status",
  role_tableheader_action: "Action",

  role_search_name: "Search by name",
  role_search_created_at: "Search by created date",
  role_search_updated_at: "Search by updated date",
  role_search_status: "Search by status",

  role_fetch_failed: "Failed to fetch role data",
  role_placeholder_rolename: "Role Name",
  role_label_rolename: "Role Name",

  role_add_success: "Add Role Success",
  role_add_failed: "Add Role Failed",
  role_edit_success: "Update Role Success",
  role_edit_failed: "Update Role Failed",

  role_activate_success: "Activate Role Success",
  role_activate_failed: "Activate Role Failed",
  role_inactivate_success: "Inactivate Role Success",
  role_inactivate_failed: "Inactivate Role Failed",

  btn_tooltip_assign: "Assign",
  role_menu_fetch_failed: "Failed to fetch role menu data",
  role_menu_edit_success: "Update Role Menu Success",
  role_menu_edit_failed: "Update Role Menu Failed",

  partner_pic: "Partner PIC",
  pic_name: "PIC Name",
  pic_email: "PIC Email",
  pic_phone: "PIC Phone",
  requester_company: "Requester Company",
  email: "Email",
  phone: "Phone Number",
  func_name: "Function",
  position: "Position",
  add_pic: "Add PIC",
  functionality: "Functionality",
  name: "Full Name",
  save: "Data has been saved",
  fail: "Failed",
  update: "Data has been updated",
  customer_pic: "Customer PIC",
  created_date: "Created Date",
  updated_date: "Updated Date",
  edit_pic: "Edit PIC",
  account_code: "Account Code",
  account_name: "Account Name",
  createddate: "Created Date",
  updateddate: "Updated Date",
  coa: "COA",
  get_failed: "Get data failed",
  level: "Level",
  parent: "Parent",
  type: "Type",
  add_success: "Successfully add data",
  add_failed: "Failed to add data",
  edit_success: "Successfully edit data",
  edit_failed: "Failed to edit data",
  filter_by: "Filter by",
  typing: "Type",
  no_photo_found: "No photos found",
  numbering: "Numbering",
  zero_lead: "Digit Number",
  separator: "Separator",

  main_email: "Main Email",
  operational_email: "Operational Email",
  finance_email: "Finance Email",
  stnk: "STNK",
  truck_year: "Truck Year",
  stnk_exp_date: "STNK Expired Date",

  // COA
  account_used_parent: "This account is already used as parent",
  account_used_freight: "This account is already used in freight element",
  success_upload_doc: "Successfully added document",
  failed_upload_doc: "Failed to add document",
  upload_coa: "Coa",

  // Driver
  add_driver: "Add Driver",

  driver_tableheader_username: "Username",

  driver: "Driver",
  driver_table_title: "List Driver",
  driver_tableheader_name: "Name",
  driver_tableheader_partnername: "Partner Name",
  driver_tableheader_driverlicenseno: "Driver License No",
  driver_tableheader_driverlicensetype: "Driver License Type",
  driver_tableheader_createddate: "Created Date",
  driver_tableheader_updateddate: "Update Date",
  driver_tableheader_status: "Status",

  driver_add_title: "Add New Driver",
  driver_add_name: "Name",
  driver_add_phone: "Phone",
  driver_add_email: "Email",
  driver_add_banktype: "Bank",
  driver_add_bankaccount: "Bank Account No",
  driver_add_birthplace: "Birth Place",
  driver_add_dob: "Date of Birth",
  driver_add_address: "Address",
  driver_add_identityno: "Identity No",
  driver_add_driverlicenseno: "Driver License No",
  driver_add_driverlicensetype: "Driver License Type",
  driver_add_idcardpath: "Id Card",
  driver_add_driverlicensepath: "Driver License",
  driver_add_driverlicenseexpdate: "Driver License Exp Date",
  driver_add_partner: "Partner",
  driver_add_success: "Add Driver Success",
  driver_add_failed: "Add Driver Failed",
  driver_add_success_text:
    "Driver data successfully added! Do you want to look the detail too?",

  driver_edit_title: "Edit Data Driver",
  driver_edit_success: "Update Driver Success",
  driver_edit_failed: "Update Driver Failed",
  driver_upload_file_failed: "Upload file failed",

  driver_activate_success: "Activate Driver Success",
  driver_activate_failed: "Activate Driver Failed",

  setup_driver_failed: "Fail to setting up driver",
  same_driver: "Driver must be different",

  // Marketplace
  type_date: "Type Date",
  job_code: "Job Code",
  description: "Description",
  posted_job_date: "Posted Job Date",
  picked_job_date: "Picked Job Date",
  posted_by: "Posted By",
  get_access_token_failed: "Failed to get access token",
  get_job_partner_failed: "Failed to get job partner data",
  get_community_request_failed: "Failed to get community request data",
  list: "List",
  order_request_no: "Order Request No",
  origin: "Origin",
  destination: "Destination",
  pickup_date: "Pickup Date",
  origin_remark: "Origin Remark",
  destination_remark: "Destination Remark",

  // Marketplace - Market API
  open_requests: "Open Requests",
  my_orders: "My Orders",
  pick_job: "Pick Job",
  cancel_order: "Cancel Order",
  create_order_request: "Create Order Request",
  request_no: "Request No",
  request_desc: "Request Description",
  status_open: "Open",
  status_picked: "Picked",
  status_expired: "Closed - Expired",
  status_completed: "Completed",
  confirm_pick_job: "Confirm Pick Job",
  confirm_pick_job_msg: "Are you sure you want to pick this job?",
  confirm_cancel_order: "Confirm Cancel Order",
  cancel_reason: "Cancellation Reason",
  cancel_reason_required: "Cancellation reason is required.",
  btn_cancel: "Cancel",
  add_order_request: "Add Order Request",
  service_category_name: "Service Category Name",
  expired_date_tooltip: "Product posting deadline",
  confirm_change_category_msg: "Changing category will clear all filled data. Continue?",
  pick_job_success: "Job picked successfully.",
  cancel_order_success: "Order cancelled successfully.",
  create_order_success: "Order request created successfully.",
  pick_job_failed: "Failed to pick job.",
  cancel_order_failed: "Failed to cancel order.",
  create_order_failed: "Failed to create order request.",
  reset: "Reset",

  please_choose_order_detail: "Please choose your order detail first",
  track_fetch_failed: "Failed to fetch tracing data",
  copy_url: "Copy URL",
  url_copied: "URL has been copied",
  url_copy_failed: "Failed to copy URL",

  profit_loss_title: "View Profit and Loss",
  order_date: "Order Date",
  total_cost: "Total Cost",
  total_revenue: "Total Revenue",
  total_profit_loss: "Total Profit Loss",
  bulk_print: "Bulk Print",
  activity: "Activity",

  btn_create_fordrive: "Create fordrive account",
  invoice_vendor: "Vendor Invoice",
  invoice: "Invoice",
  invoice_customer_pl: "Customer Invoice",

  ordertrucking_pickuptime: "Pickup Time",
  dynamic_column: "Dynamic Column",
  btn_apply:"Apply",
  btn_merge:"Merge",
  ref_number:"Reference Number",
  note:"Note",
  invoice_note:"Invoice Note",
  company: "Company",
  orderno: "Company Order Number",
  order_by: "Order By",

  origin_pic: "Origin PIC",
  origin_phone: "Origin Phone",
  destination_pic: "Destination PIC",
  destination_phone: "Destination Phone",

  transport_type: "Transport Type",

  vehicle_type: "Vehicle Type",
  max_length: "Max Length",
  max_width: "Max Width",
  max_height: "Max Height",
  max_weight: "Max Weight",
  is_show: "Show",
  is_trailer: "Trailer",
  add_vehicle_type: "Add Vehicle Type",
  edit_vehicle_type: "Edit Vehicle Type",

  order_detail: "Order Detail",
  qty: "Quantity",
  driver_name: "Driver Name",
  fleet_name: "Fleet Name",
  customer_name: "Customer Name",
  valid_date: "Valid Date",
  cost_number: "Cost Number",
  revenue_number: "Revenue Number",
  sell_number: "Sell Number",
  valid_start: "Valid Start",
  valid_end: "Valid End",
  pricing: "Pricing",
  add_pricing: "Add Pricing",
  pricing_no: "Pricing Number",
  origin_location: "Origin Location",
  destination_location: "Destination Location",
  move_type: "Move Type",
  load_type: "Load Type",
  warning_daterange: "Start date must be earlier than finish date",
  cost_amount: "Cost Amount",
  cost_total_amount: "Cost Total Amount",
  revenue_amount: "Revenue Amount",
  revenue_total_amount: "Revenue Total Amount",
  sell_amount: "Sell Amount",
  sell_total_amount: "Sell Total Amount",
  add_detail: "Add Detail",
  freight_element: "Freight Element",
  vat: "Vat",
  cost_vat: "Cost Vat",
  sell_vat: "Sell Vat",
  edit_detail: "Edit Detail",
  currency: "Currency",
  add_success_text:"Data successfully added! Do you want to add the detail too?",
  pricing_detail: "Pricing Detail",
  total: "Total",
  is_manual: "Manual",
  
  loading_list: "Loading List",
  btn_add_loading_list: "Add Loading List",
  btn_edit_loading_list: "Edit Loading List",
  loading_list_no: "Loading List Number",
  loading_list_date: "Loading List Date",
  loading_list_detail: "Loading List Detail",

  cargo_list: "Cargo List",
  btn_add_cargo_list: "Add Cargo List",
  btn_edit_cargo_list: "Edit Cargo List",
  cargo_list_no: "Cargo List Number",
  cargo_list_date: "Cargo List Date",

  order_detal: "Order Detail",
  origin_city: "Origin City",
  destination_city: "Destination City",
  ref_no: "Ref No",
  cargo_type: "Cargo Type",
  voucher_code: "Voucher Code",
  premi_amount: "Premi Amount",
  commodity_amount: "Commodity Amount",

  package: "Package",
  commodity: "Commodity",
  length: "Length",
  width: "Width",
  height: "Height",
  weight: "Weight",
  volume: "Volume",
  cargo_desc: "Cargo Description",
  cargo: "Cargo",
  
  send_to_fast: "Send to FAST",
  fast_tariff_not_configured: "The route tariff has not been set up in FAST, please contact your FAST admin to set up your route tariff",
  city: "City",
  origin_address: "Origin Address",
  destination_address: "Destination Address",
  origin_province: "Origin Province",
  destination_province: "Destination Province",
  address_detail: "Address Detail",
  origin_address_detail: "Origin Address Detail",
  destination_address_detail: "Destination Address Detail",

  confirm_customer_pic: "Are you sure you want to proceed with the changes without completing the Customer PIC data?"
};

export default englishWords;
